import * as React from "react";

import "./vebox-tree-view.scss";
import {VeboxSelectionListActionType} from "../selection_list/VeboxSelectionList";
import {VeboxTreeViewItem, VeboxTreeViewItemProps} from "./Components/VeboxTreeViewItem";
import {VeboxTreeViewRadioGroup, VeboxTreeViewRadioGroupProps} from "./Components/VeboxTreeViewRadioGroup";
import {VeboxTreeViewRadio} from "./Components/VeboxTreeViewRadio";
import {VeboxTreeCheckboxGroupProps, VeboxTreeViewCheckboxGroup} from "./Components/VeboxTreeViewCheckboxGroup";
import {VeboxTreeViewCheckbox} from "./Components/VeboxTreeViewCheckbox";
import {VeboxTreeViewCheckboxWithoutIndeterminate} from "./Components/VeboxTreeViewCheckboxWithoutIndeterminate";
import {VeboxTreeViewItemsGroup, VeboxTreeViewItemsGroupProps} from "./Components/VeboxTreeViewItemsGroup";

export const itemIndentation = 24; // 10px per level
export const expandIconWidth = 24;

export interface VeboxTreeViewInputItemProps {
    value?: any;
    disabled?: boolean;
    parentValue?: any | any[];
    siblings?: any[];
    parentState?: any;
    checked?: boolean;
    indeterminate?: boolean;
    onChange?: (value: any | any[], action?: VeboxSelectionListActionType) => void;
    isVisibilityItem?: boolean;
}


export class VeboxTreeView extends React.Component<React.HTMLAttributes<any>> {

    public static Item: React.FC<VeboxTreeViewItemProps & React.HTMLAttributes<any>> = VeboxTreeViewItem;

    public static RadioGroup: React.FC<VeboxTreeViewRadioGroupProps & React.HTMLAttributes<any>> = VeboxTreeViewRadioGroup;

    public static Radio: React.FC<VeboxTreeViewInputItemProps & VeboxTreeViewItemProps & React.HTMLAttributes<any>> = VeboxTreeViewRadio;

    public static CheckboxGroup: React.FC<VeboxTreeCheckboxGroupProps & React.HTMLAttributes<any>> = VeboxTreeViewCheckboxGroup;

    public static Checkbox: React.FC<VeboxTreeViewInputItemProps & VeboxTreeViewItemProps & React.HTMLAttributes<any>> = VeboxTreeViewCheckbox;

    public static CheckboxWithoutIndeterminate: React.FC<VeboxTreeViewInputItemProps & VeboxTreeViewItemProps & React.HTMLAttributes<any>> = VeboxTreeViewCheckboxWithoutIndeterminate;

    public static ItemsGroup: React.FC<VeboxTreeViewItemsGroupProps & React.HTMLAttributes<any>> = VeboxTreeViewItemsGroup;

    render() {
        return (
            <div {...this.props} className={"vebox-tree " + (this.props.className ?? "")}>
                {this.props.children}
            </div>
        )
    }
}